<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> داشبورد لحطه ایی </span>

    </div>

</div>

<div dir="rtl" class="form row gx-2 px-2 w-100 mt-2 py-1">

    <div class="row ">

        <div class=" col-md-6 ">

            <label> نام مدرسه </label>

            <input type="search" class="form-control" placeholder="نام مدرسه را جستجو کنید" autocomplete="off"
                [(ngModel)]="searchText" (input)="filterItems()" />

        </div>

    </div>

    <div class="row ">

        <div class="col-md-6">

            <ul class="list-group" style="max-height: 200px;overflow: auto;">

                <li class="list-group-item pointer" *ngFor="let item of filteredItems" [@fadeAnimation]
                    (click)="onSchool_change(item)">{{ item.strComment }}</li>

            </ul>

        </div>

    </div>

    <div class="row gx-2 gy-2 w-100 mt-2 ">

        <div class="p-2 col-md-6 col-12 border border-2  rounded shadow ">

            <p class="text-center f18 bg-success p-2 rounded text-white"> وضعیت کل رانندگان </p>

            <canvas id="myChart1" style="max-height: 350px !important;"></canvas>

        </div>

        <div class="p-2 col-md-6 col-12 border border-2  rounded shadow">

            <p class="text-center f18 bg-success p-2 rounded text-white"> وضعیت دانش آموزان </p>

            <canvas id="myChart2" style="max-height: 350px !important;"></canvas>

        </div>

        <div class="p-2 border border-2 rounded shadow" style="height: 650px;">

            <p class="text-center f18 bg-success p-2 rounded text-white"> پراکندگی وضعیت خودروها </p>

            <div class=" row gx-2 w-100 text-center p-2">

                <div class="col">

                    <img src="../../../../assets/Img/greenBus.png" alt="">

                    <span> فعال </span>

                </div>

                <div class="col">

                    <img src="../../../../assets/Img/blueBus.png" alt="">

                    <span> در حال سرویس </span>

                </div>

                <div class="col">

                    <img src="../../../../assets/Img/redBus.png" alt="">

                    <span> خارج از سرویس </span>

                </div>

            </div>

            <div id="map2" class="fixed-mapCluster">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                </div>

            </div>

        </div>

        <div class="p-2 border border-2 rounded shadow" style="height: 600px;">

            <p class="text-center f18 bg-success p-2 rounded text-white "> پراکندگی دانش آموزان </p>

            <div id="map1" class="fixed-mapCluster">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                </div>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="detailModal" style="z-index: 100000000000000;" tabindex="-1" aria-labelledby=""
    data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title">جزئیات دانش آموز</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div dir="rtl" class="x row p-2 gx-2 gy-2">

                <div class="col-6">

                    <label>نام</label>

                    <input type="text" [ngModel]="studentData?.strName" class="form-control">

                </div>

                <div class="col-6">

                    <label>نام خانوادگی</label>

                    <input type="text" [ngModel]="studentData?.strFamily" class="form-control">

                </div>

                <div class="col-6">

                    <label>جنسیت</label>

                    <input type="text" [ngModel]="studentData?.strSex_strSexComment" class="form-control">

                </div>

                <div class="col-6">

                    <label>شماره موبایل</label>

                    <input dir="ltr" type="text" [ngModel]="(studentData?.strMobile | faNum )" class="form-control">

                </div>

                <div class="col-6">

                    <label>مدرسه</label>

                    <input type="text" [ngModel]="studentData?.strMobileDomain_strComment" class="form-control">

                </div>

                <div class="col-6">

                    <label>فاصله تا مدرسه</label>

                    <input type="text" [ngModel]="(studentData?.fDistance | faNum ) + ' کیلومتر' " class="form-control">

                </div>

                <div class="col-12">

                    <label> آدرس </label>

                    <input type="text" [ngModel]="studentData?.strAddress" class="form-control">

                </div>

                <div class="col-md-6 col-6">

                    <label>طول جغرافیایی</label>

                    <input dir="ltr" type="text" [ngModel]="(studentData?.fOriginLon | faNum )" class="form-control">

                </div>

                <div class="col-md-6 col-6">

                    <label>عرض جغرافیایی</label>

                    <input dir="ltr" type="text" [ngModel]="(studentData?.fOrigiLat | faNum )" class="form-control">

                </div>

            </div>

        </div>

    </div>

</div>


<!--Car Status Modal-->

<div class="modal fade dirI" id="CarStatusModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" style="max-height:60vh;overflow: auto;">
                <div class="table-responsive dirI rounded-3 border border-2 my-2">
                    <table class="table table-striped " id="car-status-exel">
                        <thead>
                            <tr class="text-center">
                                <th>#</th>
                                <th>نام و نام خانوادگی </th>
                                <th>شماره موبایل راننده </th>
                                <th>پلاک </th>
                                <th>حوزه خدمت </th>
                                <th>گروه </th>
                                <th>نوع </th>
                                <th>سال ساخت</th>
                                <th class="d-none">UnitID </th>
                                <th class="d-none">کیلومتر فعلی </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let item of carStatusData;let i=index">
                                <td>{{i+1|faNum}}</td>
                                <td>{{item.strFullName}}</td>
                                <td>{{item.strCellNo | faNum}}</td>
                                <td>{{formatted_pelak(item.strVehicleNo) | faNum}}</td>
                                <td>{{item.strMobileDomain_strComment}}</td>
                                <td>{{item.strMobileGroup_strComment}}</td>
                                <td>{{item.strMobileType_strComment}}</td>
                                <td>{{item.iYearConstruction | faNum}}</td>
                                <td class="d-none">{{item.strUnitID }}</td>
                                <td class="d-none">{{item.fLastKM }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>